<template>
    <div class="max-w-xl mx-auto">
        <pageLoader v-if="!pageLoaded" />
        <div
            v-if="!!pageLoaded"
            class="py-8 px-4 mt-2 sm:mt-24 sm:pt-8 sm:pb-16 sm:px-16 sm:border border-gray-100 border-dotted"
        >
            <div class="font-bold text-xl text-center mb-2 sm:mb-8">
                {{ $t('reset.greet') }}
            </div>
            <div>
                <formFieldRow
                    name="password"
                    :label="$t('login.password')"
                    labelWidthClass="sm:w-24"
                    :errors="errors"
                >
                    <template #default="{hasError}">
                        <div class="flex flex-col sm:flex-col-reverse">
                            <div class="text-sm text-darkGrayishBlue">
                                {{ $t('login.password.hint') }}
                            </div>
                            <input
                                class="form-input"
                                type="password"
                                :class="{ 'border-red': hasError }"
                                v-model.trim="form.password"
                            />
                        </div>
                    </template>
                </formFieldRow>
                <formFieldRow
                    name="confirmPassword"
                    :label="$t('account.confirm.password')"
                    labelWidthClass="sm:w-24"
                    :errors="errors"
                >
                    <template #default="{hasError}">
                        <input
                            class="form-input"
                            type="password"
                            :class="{ 'border-red': hasError }"
                            v-model.trim="form.confirmPassword"
                        />
                    </template>
                </formFieldRow>
            </div>
            <errorBox :message="errors.server" />

            <div class="flex">
                <div class="hidden sm:block sm:w-24"></div>

                <loadingButton
                    class="text-white bg-primary border-primary flex-grow justify-center"
                    :status="saveStatus"
                    @click="confirm"
                    @successShown="$router.push({ name: 'login' })"
                >
                    {{ $t('common.confirm') }}
                </loadingButton>
            </div>
        </div>
    </div>
</template>

<script>
import formFieldRow from '@/components/formFieldRow.vue';
import pageLoader from '@/components/pageLoader.vue';
import errorBox from '@/components/errorBox.vue';
import loadingButton from '@/components/loadingButton.vue';
import { instance } from '@/utils/ajax';
import { validate, isValidPassword } from '@/utils/validationUtil';
import img4s112 from '@/assets/img/4-112.png';

async function getResetPasswordInfo(token) {
    try {
        let result = await instance.get('/api/pwd/getResetPasswordInfo', {
            params: { token }
        });
        return result.data;
    } catch (e) {
        /*eslint-disable no-console*/
        console.error('error getting reset passowrd info');
    }
    return undefined;
}

async function resetPassword(form) {
    try {
        let result = await instance.post('/api/pwd/resetPassword', form);
        return result.data;
    } catch (e) {
        /*eslint-disable no-console*/
        console.error('error register');
        return { success: false, all: 'error.connect' };
    }
}

export default {
    components: {
        formFieldRow,
        pageLoader,
        errorBox,
        loadingButton
    },
    data() {
        return {
            pageLoaded: false,
            form: {
                token: undefined,
                password: undefined,
                confirmPassword: undefined
            },
            errors: {},
            saveStatus: undefined
        };
    },
    async created() {
        this.pageLoaded = false;
        this.bubbleImg = img4s112;
        const token = this.$route.params.key;
        this.form.token = token;
        const result = await getResetPasswordInfo(token);
        if (!result) {
            this.$router.push({ name: 'pageNotFound' });
            return;
        }
        this.pageLoaded = true;
    },
    methods: {
        clearForm() {
            this.form = {
                token: this.form.token,
                password: undefined,
                confirmPassword: undefined
            };
            this.errors = {};
        },
        async confirm() {
            this.errors = {};
            const v = validate(this.errors, this.form, {
                password: {
                    required: true,
                    passwordPattern: function(v) {
                        if (!isValidPassword(v)) {
                            return 'error.password.format';
                        }
                    }
                },
                confirmPassword: {
                    required: true,
                    passwordSame: function(val, d) {
                        if (val !== d.password) {
                            return 'error.confirm.password.not.equal';
                        }
                    }
                }
            });
            if (v.hasError) {
                this.errors = v.errors;
                return;
            }

            this.saveStatus = 'loading';
            const result = await resetPassword(this.form);
            if (result.success) {
                this.saveStatus = 'success';
            } else {
                this.saveStatus = undefined;
                this.errors = result.data.errors;
            }
        }
    }
};
</script>
